import heroImg from "./intro-section-with-dropdown-navigation-main/images/image-hero-mobile.png";
import heroImgDesktop from "./intro-section-with-dropdown-navigation-main/images/image-hero-desktop.png";
import databiz from "./intro-section-with-dropdown-navigation-main/images/client-databiz.svg";
import audiophile from "./intro-section-with-dropdown-navigation-main/images/client-audiophile.svg";
import meet from "./intro-section-with-dropdown-navigation-main/images/client-meet.svg";
import maker from "./intro-section-with-dropdown-navigation-main/images/client-maker.svg"; 

const Section = () => {
    return ( 
        <section className="flex flex-col items-center justify-center lg:flex-row-reverse lg:px-10">
            <div className="mt-2">
                <img className="block lg:hidden" src={heroImg} alt="hero-img"/>
                <img className="hidden min-h-full lg:block" src={heroImgDesktop} alt="hero-img"/>

            </div>

            <div className="flex flex-col items-center justify-center px-3 lg:pr-20 lg:items-start lg:mt-8">
                <h1 className="mt-7 mb-4 text-3xl font-bold tracking-wide lg:text-left lg:text-6xl lg:mb-10">Make remote work </h1>
                <p className="text-center mb-4 min-w-4xl lg:text-start lg:mb-10 lg:text-lg">Get your team in sync, no matter your location. Streamline processes, create team rituals, and watch productivity soar.</p>
                <button className="bg-black border border-black text-white px-4 py-2 rounded-xl mb-4 hover:bg-white hover:text-black lg:mb-16">Learn More</button>

                <ul className="flex space-x-12 items-center mt-6 mb-6">
                    <li>
                        <img className="w-16 lg:w-28" src={databiz} alt="databiz-img" />
                    </li>
                    <li>
                        <img className="w-16 lg:w-28" src={audiophile} alt="audiophile-img" />
                    </li>
                    <li>
                        <img className="w-16 lg:w-28" src={meet} alt="meet-img" />
                    </li>
                    <li>
                        <img className="w-16 lg:w-28" src={maker} alt="maker-img" />
                    </li>
                </ul>
            </div>
        </section>
     );
}
 
export default Section;